import React from "react";
import { Mutation } from "react-apollo";

import cancelRegistrationMutation from "../../../../gql/cancelRegistrationMutation";
import { toastTranslated } from "../../../../toastr/toastr";
import transError from "../../../../i18n/fieldError";
import Cancel from "./Cancel";

function CancelContainer({ trainingUnitId, memberId, onFinished }) {
  const handleCancel = mutateFunc => () => {
    mutateFunc({
      variables: {
        input: {
          trainingUnitId: trainingUnitId,
          memberId: memberId
        }
      }
    }).then(({ data: { result } }) => {
      if (result.error) {
        result.error.errors.forEach(error => {
          toastTranslated(
            "error",
            transError(`cancelRegistration.${error.code}`, error.arguments)
          );
        });

        return;
      }

      toastTranslated("success", "coursePlan.events.registrationCancelled");

      onFinished();
    });
  };

  return (
    <Mutation mutation={cancelRegistrationMutation} ignoreResults={false}>
      {mutateFunc => (
        <>
          <Cancel
            onCancel={handleCancel(mutateFunc)}
            trainingUnitId={trainingUnitId}
            memberId={memberId}
          />
        </>
      )}
    </Mutation>
  );
}

CancelContainer.displayName =
  "coursePlan/details/registrations/CancelContainer";

export default React.memo(CancelContainer);
